:host {
  --cms-font-size: initial;
  --cms-line-height: initial;
  --cms-font-family: initial;
  --cms-default-grid-area: auto / auto / auto / span 12;
  --cms-spacing-top: initial;
  --cms-spacing-bottom: initial;
  --cms-spacing-left-right: var(--cms-spacing-100);
  --cms-headline-position: left;
  --cms-headline-text-color: var(--cms-text-color, var(--cms-theme-text-color));
  display: block;
}

:host([font-brand="brand1"]) {
  --cms-font-family: var(--cms-brandfont1);
}

:host([font-brand="brand2"]) {
  --cms-font-family: var(--cms-brandfont2);
}

:host([size="xl"]) {
  --cms-font-size: var(--cms-font-size-225);
  --cms-line-height: var(--cms-line-height-111);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([size="lg"]) {
  --cms-font-size: var(--cms-font-size-200);
  --cms-line-height: var(--cms-line-height-112);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([size="md"]) {
  --cms-font-size: var(--cms-font-size-175);
  --cms-line-height: var(--cms-line-height-114);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([size="sm"]) {
  --cms-font-size: var(--cms-font-size-150);
  --cms-line-height: var(--cms-line-height-116);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([size="xs"]) {
  --cms-font-size: var(--cms-font-size-125);
  --cms-line-height: var(--cms-line-height-120);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([is-adaptive][headline-tag="h1"]) {
  --cms-font-size: var(--cms-adaptive-font-size-200);
  --cms-line-height: var(--cms-line-height-111);
  // --cms-spacing-top: var(--cms-spacing-150);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([is-adaptive][headline-tag="h2"]) {
  --cms-font-size: var(--cms-adaptive-font-size-175);
  --cms-line-height: var(--cms-line-height-114);
  // --cms-spacing-top: var(--cms-spacing-150);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([is-adaptive][headline-tag="h3"]) {
  --cms-font-size: var(--cms-font-size-150);
  --cms-line-height: var(--cms-line-height-116);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([headline-tag="h3"]) {
  --cms-font-size: var(--cms-font-size-150);
  --cms-line-height: var(--cms-line-height-116);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-075);
}

:host([headline-tag="h4"]) {
  --cms-font-size: var(--cms-font-size-125);
  --cms-line-height: var(--cms-line-height-120);
  --cms-spacing-top: 0;
  --cms-spacing-bottom: var(--cms-spacing-100);
}

:host([headline-position="center"]) {
  --cms-headline-position: center;
}

:host([layout="inline"]) {
  .headline-wrapper {
    padding: 0;
    margin: 0;

    .headline {
      padding: 0;
      margin: 0;
    }
  }
}

.headline {
  color: var(--cms-headline-text-color);
  font-size: var(--cms-font-size);
  line-height: var(--cms-line-height);
  margin-top: var(--cms-spacing-top);
  margin-bottom: var(--cms-spacing-bottom);
  font-family: var(--cms-font-family);
  font-weight: var(--cms-heading-base-font-weight);
  text-align: var(--cms-headline-position);
}

.headline a {
  color: inherit;
}

.headline-wrapper {
  box-sizing: inherit;
  @include cms-default-grid-container;
}

.headline-wrapper>* {
  grid-area: var(--cms-default-grid-area);
}

@include media-width($breakpoint-sm) {
  :host([layout="two-thirds"]) {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}